import axios from 'axios';
import TomSelect from 'tom-select';

declare let core_object: any;

export default function getCity(elSelect: string = '#select-city'){
    
    const el = document.querySelector(elSelect) as HTMLSelectElement | null;

    if(el === null){

        return null;

    }

    const settings: any = {
        plugins: ['dropdown_input'],
        valueField: 'id',
        labelField: 'name',
        searchField: 'name',
        load: function (query, callback) {
            
            // Post data
            const post_data = {
                'search': query,
            };
        
            // Query string
            const queryString = new URLSearchParams(post_data).toString();

            // Call ajax
            axios.post(core_object.rest_urls.select_city, queryString)
                .then(function (response: any) {

                callback(response.data);

            })
            .catch(function (error: any){

                console.log(error);

            });
        },
        render: {
            option: function (item, escape) {
                return '<span class="block w-full fluid-text-xs">'+ escape(item.name) +'</span>';
            },
            item: function (item, escape) {
                return '<span>'+ escape(item.name) +'</span>';
            },
        }
    };

    return new TomSelect(elSelect, settings);

}